import { FormControl, ValidatorFn, Validators } from "@angular/forms";
import { HHMM } from "@rrsolutionsit/atl-utils";

/** `HH:mm`, as the logbook keeps a time of day. */
const TIME_OF_DAY = /^\d{2}:\d{2}$/;

/** A time of day: `HHMM` reads it back unchanged, never negative and within the 24 hours. */
export const timeOfDay: ValidatorFn = (control) => {
    if (!control.value) return null;
    const value = new HHMM(control.value);
    return TIME_OF_DAY.test(control.value) && value.value === control.value && !value.isNegative && value.hours < 24 ? null : { timeOfDay: true };
};

/** An amount of hours, `HH:MM` with up to three digits for the hours as the app's schemas take it, never negative. */
export const duration: ValidatorFn = (control) =>
    !control.value || (/^\d{2,3}:\d{2}$/.test(control.value) && HHMM.normalizeTotal(control.value) !== null) ? null : { duration: true };

export const text = (value: string | null = null) => new FormControl<string | null>(value);
export const amount = (value: number | null = null) => new FormControl<number | null>(value, Validators.min(0));
export const flag = (value: boolean) => new FormControl<boolean>(value, { nonNullable: true });
export const time = (value: string | null) => new FormControl<string | null>(value, timeOfDay);
export const hours = (value: string | null) => new FormControl<string | null>(value, duration);
export const id = (value: number | null) => new FormControl<number | null>(value);
